import { TemplateElement, defineElement, html } from '@webtides/element-js';
import { getSpriteSymbol } from '../../stores/svg-sprite-store.js';
import style from './icon.css';

/**
 * @property {string} name
 * @property {number} size
 */
export default class Icon extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            name: '',
            size: '',
        };
    }

    afterUpdate() {
        this._applySymbol();
    }

    async _applySymbol() {
        const svg = this.$refs.svg;
        if (!svg || !svg.querySelector('use')) return;
        const name = this.name;
        const symbol = await getSpriteSymbol(`icon-${name}`);
        if (!symbol || this.name !== name) return;
        for (const attr of ['viewBox', 'fill']) {
            if (symbol.hasAttribute(attr)) {
                svg.setAttribute(attr, symbol.getAttribute(attr));
            } else {
                svg.removeAttribute(attr);
            }
        }
        svg.replaceChildren(...[...symbol.children].map((node) => node.cloneNode(true)));
    }

    template() {
        return html`
            <i class="Icon" data-icon="${this.name}">
                <svg aria-hidden="true" ref="svg"><use href="#icon-${this.name}"></use></svg>
            </i>
        `;
    }
}

defineElement('mb-icon', Icon);
